import Insurances from "@components/Reason/Insurances";
import {useTranslation} from "@i18n/client";
import React from "react";

const Header: React.FC = () => {
  const i18n = useTranslation();

  return (
    <div className="bg-darkerBlue pt50 pt34-lg pt24-sm contrast-tbb">
      <Insurances
        headerText={i18n.t(
          "We accept most major insurance plans. No insurance? See our clear prices before you book.",
        )}
        isFullWidth
      />
    </div>
  );
};

export default Header;
